
import { defineComponent } from "vue";

import ConsentHidden from "~/vue/organisms/consents/ConsentHidden.vue";
import ViewFileManager from "~/vue/organisms/views/ViewFileManager.vue";
import LinkDocumentConsent from "~/vue/atoms/links/LinkDocumentConsent.vue";

export default defineComponent({
	components: {
		"consent--hidden": ConsentHidden,
		"link--document-consent": LinkDocumentConsent,
		"view--file-manager": ViewFileManager,
	},
});
